module.exports = __webpack_public_path__ + "static/SDVOSB-40d707aa6284daa2922dd22b0ad92888.svg";